import { render, staticRenderFns } from "./OrderTicketAnswer.vue?vue&type=template&id=07d48eeb&scoped=true&"
import script from "./OrderTicketAnswer.vue?vue&type=script&lang=js&"
export * from "./OrderTicketAnswer.vue?vue&type=script&lang=js&"
import style0 from "./OrderTicketAnswer.vue?vue&type=style&index=0&id=07d48eeb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d48eeb",
  null
  
)

export default component.exports